import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/Infrastructure/State';

export const selectShippingMethods = createSelector(
  (state: RootState) => state.shippingMethods,
  (shippingMethods) => ({
    data: shippingMethods?.data,
    isLoading: shippingMethods?.isLoading,
    error: shippingMethods?.error
  })
);

const useShippingMethods = () => {
  const response = useSelector(selectShippingMethods);
  return response;
};

export default useShippingMethods;
